'use client'
import { tw } from 'utils/classnames'

import { useOpenCategories } from './context'

type SectionProps = React.HTMLAttributes<HTMLDivElement>

export function Section({ children, className, ...rest }: SectionProps) {
  const open = useOpenCategories()
  const isAnyOpen = open.length > 0
  return (
    <section
      className={tw(
        'rounded-2 mb-4 w-full p-6 pb-12 transition-colors ease-in-out',
        isAnyOpen && 'bg-cf-white',
        className,
      )}
      {...rest}
    >
      {children}
    </section>
  )
}
